import { render, staticRenderFns } from "./linkInvalid.vue?vue&type=template&id=8d796a8a&scoped=true"
import script from "./linkInvalid.vue?vue&type=script&lang=js"
export * from "./linkInvalid.vue?vue&type=script&lang=js"
import style0 from "./linkInvalid.vue?vue&type=style&index=0&id=8d796a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d796a8a",
  null
  
)

export default component.exports